// default styles/classes for PDF patching
export const defaultPdfRules = {
  h1: {
    style: {
      fontSize: "20px",
      fontWeight: "700",
    },
  },
  h2: {
    style: {
      fontSize: "18px",
      fontWeight: "700",
    },
  },
  h3: {
    style: {
      fontSize: "16px",
      fontWeight: "700",
    },
  },

  // body text & lists
  p: { style: { margin: "0 0 8px" } },
  ul: { style: { paddingLeft: "1.5rem" } },
  ol: { style: { paddingLeft: "1.5rem" } },
  li: { style: { margin: "0.25em 0" } },

  // quotes & images
  blockquote: {
    style: {
      borderLeft: "4px solid #E0E2E6",
      margin: "12px 0",
      padding: "6px 12px",
      color: "#555",
    },
  },
  //   img: { style: { display: "block", maxWidth: "100%", margin: "12px auto" } },
  img: {
    style: {
      width: "50%",
      height: "auto",
      display: "block",
      margin: "12px auto",
    },
  },

  // citation-style links
  a: {
    style: {
      fontSize: "0.85em",
      verticalAlign: "super",
      textDecoration: "none",
      margin: "0 2px",
    },
    class: "reference",
  },

  /* ---- TABLES ---- */
  table: {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid #C8CCD3",
      margin: "12px 0",
    },
  },
  "thead th": {
    style: {
      fontWeight: "700",
      background: "#F6F7F9",
      border: "1px solid #C8CCD3",
      padding: "6px 8px",
      textAlign: "left",
    },
  },
  "tbody td": {
    style: {
      border: "1px solid #C8CCD3",
      padding: "6px 8px",
      verticalAlign: "top",
    },
  },
  "tfoot td": {
    style: {
      borderTop: "2px solid #C8CCD3",
      padding: "6px 8px",
    },
  },
  tr: { style: { pageBreakInside: "avoid" } },
};

export function transformForPdf(html, rules = {}) {
  const DEFAULT_TITLE = "";

  const wrap = (inner) =>
    `<html><head></head><body>${inner || ""}</body></html>`;

  if (!html) return wrap("");

  try {
    const doc = new DOMParser().parseFromString(html, "text/html");

    // --- helpers for inline style/class merging ---
    const toKebab = (s) => s.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);

    const styleStrToObj = (s) => {
      const out = {};
      (s || "")
        .split(";")
        .map((p) => p.trim())
        .filter(Boolean)
        .forEach((pair) => {
          const i = pair.indexOf(":");
          if (i > -1) {
            const k = pair.slice(0, i).trim().toLowerCase();
            const v = pair.slice(i + 1).trim();
            if (k) out[k] = v;
          }
        });
      return out;
    };

    const mergeInlineStyle = (el, styleObj) => {
      if (!styleObj) return;
      const curr = styleStrToObj(el.getAttribute("style"));
      for (const [key, val] of Object.entries(styleObj)) {
        if (val == null || String(val).trim() === "") continue;
        curr[toKebab(key.trim())] = String(val).trim();
      }
      const next = Object.entries(curr)
        .map(([k, v]) => `${k}: ${v}`)
        .join("; ");
      if (next) el.setAttribute("style", next);
      else el.removeAttribute("style");
    };

    const addClass = (el, classes) => {
      if (!classes) return;
      const prev = (el.getAttribute("class") || "")
        .split(/\s+/)
        .filter(Boolean);
      const set = new Set(prev);
      const add = Array.isArray(classes)
        ? classes
        : String(classes).split(/\s+/);
      add.forEach((c) => c && set.add(c));
      el.setAttribute("class", Array.from(set).join(" "));
    };

    Object.entries(rules).forEach(([selector, rule]) => {
      const cfg =
        rule && (rule.style || rule.class || rule.addClass)
          ? rule
          : { style: rule };
      doc.body.querySelectorAll(selector).forEach((el) => {
        if (cfg.style) mergeInlineStyle(el, cfg.style);
        addClass(el, cfg.class || cfg.addClass);
      });
    });

    return wrap(doc.body.innerHTML);
  } catch {
    // On parse failure
    return wrap(html);
  }
}
